import "../App.css";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import * as bootstrap from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, useController, useWatch } from "react-hook-form";
import axios from "axios";
import "./ThankYou";
import "./Error";
import Download from "../components/downloads/A-525DS Rev A.pdf";
import Notice from "../components/downloads/DeVilbiss_525_Manual_Update_Customer_Notification_Letter.pdf";
import { getEnv } from "./helpers/Config";
import { Axios } from "../axios/Axios";
import ReactGA from "react-ga";
import ReactDatePicker from "react-datepicker";
import "react-upload-gallery/dist/style.css";
import "react-datepicker/dist/react-datepicker.css";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const Acknowledgement = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const [formValues, setFormValues] = useState({ data: null });

  //This useEffect is for google analytics
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    setInstance(
      location.state.values.find((a) => a.dynamicFieldId == 59229).instanceId
    );
    // setDownload(
    //   "https://" +
    //     window.location.hostname +
    //     "/assets/DeVilbissFiles/" +
    //     location.state.values.find((a) => a.dynamicFieldId == 59229)
    //       .fieldValue +
    //     ".xlsx"
    // );
    window.scrollTo(0, 0);
  }, []);
  let navigate = useNavigate();
  const siteId = 52;
  let url = getEnv();
  const { t, i18n } = useTranslation();
  const {
    register,
    handleSubmit,
    getValues,
    watch,
    trigger,
    setValue,
    formState: { errors },
    reset,
    control,
    clearErrors,
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
  });
  const download = async (url) => {
    var isDownload = await axios.get(url, {
      responseType: "blob",
    });
    if (isDownload) {
      const downloadURL = window.URL.createObjectURL(isDownload.data);
      const link = document.createElement("a");
      link.href = downloadURL;
      link.setAttribute(
        "download",
        location.state.values.find((a) => a.dynamicFieldId == 59229)
          .fieldValue + ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };
  const onSubmit = (data) => {
    setIsSubmitting(true);
    let SFDFI = [
      {
        DynamicFieldId: 33504,
        FieldValue: data.address,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33512,
        FieldValue: data.city,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33508,
        FieldValue: data.email,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33502,
        FieldValue: data.name,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33515,
        FieldValue: data.postalCode,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33507,
        FieldValue: data.phoneNumber,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33514,
        FieldValue: data.state,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 59231,
        FieldValue: "Yes",
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 59230,
        FieldValue: new Date().toLocaleDateString(),
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67758,
        FieldValue: data.custNum,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      // Site Specific Fields

      {
        DynamicFieldId: 67747,
        FieldValue: "Yes",
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67749,
        FieldValue: "Yes",
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67751,
        FieldValue: "Yes",
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67769,
        FieldValue: data.qtyOnHand,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67770,
        FieldValue: data.qtySold,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67771,
        FieldValue: data.qtyInService,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67772,
        FieldValue: data.qtyTotal.toString(),
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33505,
        FieldValue: data.company,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },

      {
        DynamicFieldId: 67753,
        FieldValue: data.signature,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67776,
        FieldValue: "568",
        //FieldValue: "Completed - Via Website",
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33555,
        FieldValue: data.title,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 59229,
        FieldValue: data.verifyCode,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      },
    ];

    if (data.address2) {
      SFDFI.push({
        DynamicFieldId: 33506,
        FieldValue: data.address2,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      });
    }
    if (watchCheckYes) {
      SFDFI.push({
        DynamicFieldId: 67773,
        FieldValue: "Yes",
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      });
    } else {
      SFDFI.push({
        DynamicFieldId: 67773,
        FieldValue: "No",
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      });
    }

    if (data.injuryDetail) {
      SFDFI.push({
        DynamicFieldId: 67775,
        FieldValue: data.injuryDetail,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.comments) {
      SFDFI.push({
        DynamicFieldId: 67752,
        FieldValue: data.comments,
        Alias: "",
        InstanceID: instance,
        DynamicFieldInstanceID: 0,
      });
    }
    console.log(data);

    var SimpleSuperFormDTO = {
      FormInstances: {
        DefinitionId: 501,
        CompanyId: 104,
        CreatedBy: 803,
        CreatedFor: 803,
        WorkTypeItemId: 3522,
        WorkFlowOverallStatusId: 4,
        WorkflowId: 1,
        Source: 3,
        InstanceID: instance,
      },
      DynamicFieldslist: SFDFI,
    };
    SimpleSuperFormDTO.FormInstances.CreatedDate = new Date();
    console.log(SimpleSuperFormDTO);
    axios({
      method: "post",
      url: url + "/SuperForm/SaveSimpleSuperForm",
      data: SimpleSuperFormDTO,
    })
      .then((response) => {
        console.log("success");
        setIsSubmitting(false);
        setInstance(response.data.formInstances.instanceId);
        navigate("/ThankYou", {
          state: { id: instance, formData: data, checkYes: watchCheckYes },
          replace: true,
        });
        // var pdf = new jsPDF({
        //   format: [700, 2000],
        //   unit: "pt",
        // });
        // pdf.html(document.getElementById("pdfStart"), {
        //   callback: function (pdf) {
        //     var blob = pdf.output("blob");
        //     var array = pdf.output("arraybuffer");
        //     var file = new File(
        //       [blob],
        //       location.state.values.find((a) => a.dynamicFieldId == 59229)
        //         .fieldValue + ".pdf",
        //       {
        //         lastModified: new Date().getTime(),
        //       }
        //     );
        //     var formData = new FormData();
        //     formData.append("file", file, data.verifyCode + ".pdf");
        //     try {
        //       const response = axios.post(
        //         "https://prod-17.centralus.logic.azure.com:443/workflows/0d3272e453c64b229a4215e2a09b0aa6/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=I2VYiSsZeK2-SmsnhnxpncB0KEk3FdL93-uUjRxrEn0&comp=Drive Devilbiss&&folder=FilePickup",
        //         formData
        //       );
        //       if (response) {
        //         console.log("success");
        //         //var bytes = new Uint32Array(array);
        //         Axios.email(data, instance, file);

        //         return true;
        //       } else {
        //         return false;
        //       }
        //     } catch (error) {
        //       if (error.response) {
        //         // Request made but the server responded with an error
        //         console.log(error.response.data);
        //         console.log(error.response.status);
        //         console.log(error.response.headers);
        //       } else if (error.request) {
        //         // Request made but no response is received from the server.
        //         console.log(error.request);
        //       } else {
        //         // Error occured while setting up the request
        //         console.log("Error", error.message);
        //       }
        //     }
        //     var blobUrl = URL.createObjectURL(blob); //<--- THE ERROR APPEARS HERE

        //     window.open(blobUrl);
        //   },
        //   autoPaging: "text",
        //   x: 10,
        //   y: 10,
        //   width: "100%",
        //   html2canvas: {
        //     scale: 0.5,
        //   },
        // });
      })
      .catch((response) => {
        setIsSubmitting(false);
        console.log("fail");
        navigate("/Error", { replace: true });
      });
  };
  const [instance, setInstance] = useState();
  const [checkRequired, setCheckRequired] = useState(true);
  const watchCheckYes = watch("checkYes", false);
  const watchCheckNo = watch("checkNo", false);
  const [excelURL, setExcelURL] = useState(
    "https://" +
      window.location.hostname +
      "/assets/DeVilbissFiles/" +
      location.state.values.find((a) => a.dynamicFieldId == 59229).fieldValue +
      ".xlsx"
  );
  const watchQuantities = watch(["qtyOnHand", "qtySold", "qtyInService"]);
  const watchSigName = watch("name", null);
  const watchSigTitle = watch("title", null);

  useEffect(() => {
    var total = watchQuantities
      .map(function (elt) {
        // assure the value can be converted into an integer
        return /^\d+$/.test(elt) ? parseInt(elt) : 0;
      })
      .reduce(function (a, b) {
        // sum all resulting numbers
        return a + b;
      });
    setValue("qtyTotal", total);
  }, [watchQuantities]);
  useEffect(() => {
    setValue("sigName", watchSigName);
    setValue("sigTitle", watchSigTitle);
  }, [watchSigName, watchSigTitle]);
  return (
    <div id="pdfStart">
      <bootstrap.Form onSubmit={handleSubmit(onSubmit)}>
        <bootstrap.Container fluid>
          <bootstrap.Row>
            <bootstrap.Col>
              <h2 className="text-center">
                <u>{t("step6.6A")}</u>
              </h2>
              <h2 className="text-center pt-1">
                <u>{t("step6.6A1")}</u>
              </h2>
              <p className="lead py-1">
                <u>{t("step6.6C")}</u>
              </p>
              <p className="lead py-1">{t("step6.6D")}</p>
              <p className="lead py-1">{t("step6.6E")}</p>
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Row className="text-center col align-content-lg-center pt-5">
            <bootstrap.Col>
              <bootstrap.Button
                className="btn btn-primary btn-lg pt-1"
                type="button"
                onClick={() => {
                  download(excelURL);
                }}
                id="serialButton"
              >
                {t("buttons.serial")}
              </bootstrap.Button>
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Row>
            <bootstrap.Col>
              {/* Verification Code */}
              <bootstrap.Form.Label htmlFor="verifyCode" className="lead">
                {t("contactStep.verification")}
              </bootstrap.Form.Label>
              <bootstrap.InputGroup className="mb-3">
                <bootstrap.Form.Control
                  type="text"
                  id="verifyCode"
                  readOnly={true}
                  defaultValue={
                    location.state.values.find((a) => a.dynamicFieldId == 59229)
                      .fieldValue
                  }
                  {...register("verifyCode", {
                    required: false,
                    maxLength: 80,
                  })}
                />{" "}
              </bootstrap.InputGroup>
              <p className="lead py-1">
                <u>{t("step6.6F")}</u>
              </p>
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Row>
            <bootstrap.Col>
              {/* Customer Number */}
              <bootstrap.FloatingLabel label={t("step6.6G")} className="lead">
                <bootstrap.Form.Control
                  type="text"
                  id="custNum"
                  placeholder={t("step6.6G")}
                  readOnly={true}
                  defaultValue={
                    location.state.values.find((a) => a.dynamicFieldId == 67758)
                      .fieldValue
                  }
                  className="lead"
                  {...register("custNum", {
                    required: false,
                    maxLength: 80,
                  })}
                />
              </bootstrap.FloatingLabel>
              {/* Company */}
              <bootstrap.FloatingLabel
                label={t("step6.6H")}
                className="lead py-2"
              >
                <bootstrap.Form.Control
                  type="text"
                  id="company"
                  placeholder={t("step6.6H")}
                  defaultValue={
                    location.state.values.find((a) => a.dynamicFieldId == 33505)
                      .fieldValue
                  }
                  className="lead"
                  {...register("company", {
                    required: true,
                    maxLength: 80,
                  })}
                />
              </bootstrap.FloatingLabel>
              {/* Adress Line 1 */}
              <bootstrap.FloatingLabel
                label={t("step6.6I")}
                className="lead py-2"
              >
                <bootstrap.Form.Control
                  placeholder={t("step6.6I")}
                  type="text"
                  id="address"
                  defaultValue={
                    location.state.values.find((a) => a.dynamicFieldId == 33504)
                      .fieldValue
                  }
                  {...register("address", {
                    required: true,
                  })}
                />
              </bootstrap.FloatingLabel>
              {errors.address && (
                <bootstrap.Alert className="" variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}

              {/* City */}
              <bootstrap.FloatingLabel
                label={t("step6.6J")}
                className="lead py-2"
              >
                <bootstrap.Form.Control
                  placeholder={t("step6.6J")}
                  type="text"
                  id="city"
                  defaultValue={
                    location.state.values.find((a) => a.dynamicFieldId == 33512)
                      .fieldValue
                  }
                  {...register("city", {
                    required: true,
                  })}
                />
              </bootstrap.FloatingLabel>
              {errors.city && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
              {/* State */}
              <bootstrap.FloatingLabel
                label={t("step6.6K")}
                className="lead py-2"
              >
                <bootstrap.Form.Control
                  placeholder={t("step6.6K")}
                  type="text"
                  className="lead"
                  aria-label="Default State Label"
                  id="state"
                  defaultValue={
                    location.state.values.find((a) => a.dynamicFieldId == 33514)
                      .fieldValue
                  }
                  {...register("state", {
                    required: true,
                  })}
                />
              </bootstrap.FloatingLabel>
              {errors.state && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}

              {/* Postal */}
              <bootstrap.FloatingLabel
                label={t("step6.6L")}
                className="lead py-2"
              >
                <bootstrap.Form.Control
                  placeholder={t("step6.6L")}
                  type="text"
                  id="postal"
                  defaultValue={
                    location.state.values.find((a) => a.dynamicFieldId == 33515)
                      .fieldValue
                  }
                  {...register("postalCode", {
                    required: true,
                    min: 5,
                    // pattern:
                    //   /\d{5}(-\d{4})?/i |
                    //   /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ -]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i,
                  })}
                />
              </bootstrap.FloatingLabel>
              {errors.postalCode && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
              {/* Contact Name */}
              <bootstrap.FloatingLabel
                label={t("step6.6M")}
                className="lead py-2"
              >
                <bootstrap.Form.Control
                  placeholder={t("step6.6M")}
                  type="text"
                  id="name"
                  {...register("name", {
                    required: true,
                    maxLength: 80,
                  })}
                />
              </bootstrap.FloatingLabel>
              {errors.name && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
              {/* Title */}
              <bootstrap.FloatingLabel
                label={t("step6.6N")}
                className="lead py-2"
              >
                <bootstrap.Form.Control
                  placeholder={t("step6.6N")}
                  id="title"
                  {...register("title", {
                    required: true,
                    maxLength: 100,
                  })}
                />
              </bootstrap.FloatingLabel>
              {errors.title && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
              {/* Phone */}
              <bootstrap.FloatingLabel
                label={t("step6.6O")}
                className="lead py-2"
              >
                <bootstrap.Form.Control
                  placeholder={t("step6.6O")}
                  type="text"
                  id="phone"
                  defaultValue={
                    location.state.values.find((a) => a.dynamicFieldId == 33507)
                      .fieldValue
                  }
                  {...register("phoneNumber", {
                    required: true,
                    //maxLength: 10,
                    //pattern: /\d{10}/i,
                  })}
                />
              </bootstrap.FloatingLabel>
              {errors.phoneNumber && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
              {errors.phoneNumber && errors.phoneNumber.type === "pattern" && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.phoneFormat")}
                  </p>
                </bootstrap.Alert>
              )}
              {/* Email */}
              <bootstrap.FloatingLabel
                label={t("step6.6P")}
                className="lead py-2"
              >
                <bootstrap.Form.Control
                  placeholder={t("step6.6P")}
                  type="email"
                  id="email"
                  aria-describedby="emailtext"
                  {...register("email", {
                    required: true,
                    pattern:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  })}
                />
              </bootstrap.FloatingLabel>
              {errors.email && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
              {errors.email && errors.email.type === "pattern" && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.emailFormat")}
                  </p>
                </bootstrap.Alert>
              )}
              {/* Verify Email */}
              <bootstrap.FloatingLabel
                label={t("step6.6P1")}
                className="lead py-2"
              >
                <bootstrap.Form.Control
                  placeholder={t("step6.6P1")}
                  type="email"
                  id="verifyEmail"
                  aria-describedby="verifyEmailText"
                  {...register("verifyEmail", {
                    required: true,
                    pattern:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    validate: {
                      mismatch: (value) => {
                        const { email } = getValues();
                        return email === value;
                      },
                    },
                  })}
                />
              </bootstrap.FloatingLabel>
              {errors.verifyEmail && errors.verifyEmail.type === "mismatch" && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.emailMismatch")}
                  </p>
                </bootstrap.Alert>
              )}
              {errors.verifyEmail && errors.verifyEmail.type === "pattern" && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.emailFormat")}
                  </p>
                </bootstrap.Alert>
              )}
              {errors.verifyEmail && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Row>
            <bootstrap.Col>
              <p className="lead py-1">
                <u>{t("step6.6Q")}</u>
              </p>
              {/* Check 1*/}
              <bootstrap.InputGroup>
                <bootstrap.Form.Check type="checkbox">
                  <bootstrap.Form.Check.Input
                    type="checkbox"
                    id="check1"
                    {...register("check1", { required: true })}
                  />
                  <bootstrap.Form.Check.Label className="lead">
                    {t("step6.6R")}{" "}
                  </bootstrap.Form.Check.Label>
                </bootstrap.Form.Check>
              </bootstrap.InputGroup>
              {errors.check1 && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
              {/* Check 2*/}
              <bootstrap.InputGroup>
                <bootstrap.Form.Check type="checkbox">
                  <bootstrap.Form.Check.Input
                    type="checkbox"
                    id="check2"
                    {...register("check2", { required: true })}
                  />
                  <bootstrap.Form.Check.Label className="lead">
                    {t("step6.6S")}{" "}
                  </bootstrap.Form.Check.Label>
                </bootstrap.Form.Check>
              </bootstrap.InputGroup>
              {errors.check2 && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
              {/* Check 3*/}
              <bootstrap.InputGroup>
                <bootstrap.Form.Check type="checkbox">
                  <bootstrap.Form.Check.Input
                    type="checkbox"
                    id="check3"
                    {...register("check3", { required: true })}
                  />
                  <bootstrap.Form.Check.Label className="lead">
                    {t("step6.6T")}{" "}
                  </bootstrap.Form.Check.Label>
                </bootstrap.Form.Check>
              </bootstrap.InputGroup>
              {errors.check3 && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
              <p className="lead py-1">{t("step6.6U")}</p>
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Row>
            <bootstrap.Col className="col-2"></bootstrap.Col>
            <bootstrap.Col>
              {" "}
              <bootstrap.Table responsive striped bordered hover>
                <thead>
                  <tr>
                    <th className="text-center"></th>
                    <th className="text-center">{t("step6.table1")}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="lead">{t("step6.table2")}</td>
                    <td className="lead">
                      {/* Qty On Hand */}
                      <bootstrap.InputGroup className="mb-3">
                        <bootstrap.Form.Control
                          type="number"
                          id="qtyOnHand"
                          {...register("qtyOnHand", {
                            required: true,
                            validate: {
                              belowMinimum: (value) => parseFloat(value) >= 0,
                            },
                          })}
                        />
                      </bootstrap.InputGroup>
                      {errors.qtyOnHand &&
                        errors.qtyOnHand.type === "belowMinimum" && (
                          <bootstrap.Alert className="" variant="danger">
                            <p className="lead text-danger text-center">
                              {t("errors.required")}
                            </p>
                          </bootstrap.Alert>
                        )}
                    </td>
                  </tr>
                  <tr>
                    <td className="lead">{t("step6.table3")}</td>
                    <td className="lead">
                      {/* Qty Sold*/}
                      <bootstrap.InputGroup className="mb-3">
                        <bootstrap.Form.Control
                          type="number"
                          id="qtySold"
                          {...register("qtySold", {
                            required: true,
                            validate: {
                              belowMinimum: (value) => parseFloat(value) >= 0,
                            },
                          })}
                        />
                      </bootstrap.InputGroup>
                      {errors.qtySold &&
                        errors.qtySold.type === "belowMinimum" && (
                          <bootstrap.Alert className="" variant="danger">
                            <p className="lead text-danger text-center">
                              {t("errors.required")}
                            </p>
                          </bootstrap.Alert>
                        )}
                    </td>
                  </tr>
                  <tr>
                    <td className="lead">{t("step6.table4")}</td>
                    <td className="lead">
                      {/* Qty In Service*/}
                      <bootstrap.InputGroup className="mb-3">
                        <bootstrap.Form.Control
                          type="number"
                          id="qtyInService"
                          {...register("qtyInService", {
                            required: true,
                            validate: {
                              belowMinimum: (value) => parseFloat(value) >= 0,
                            },
                          })}
                        />
                      </bootstrap.InputGroup>
                      {errors.qtyInService &&
                        errors.qtyInService.type === "belowMinimum" && (
                          <bootstrap.Alert className="" variant="danger">
                            <p className="lead text-danger text-center">
                              {t("errors.required")}
                            </p>
                          </bootstrap.Alert>
                        )}
                    </td>
                  </tr>
                  <tr>
                    <td className="lead">{t("step6.table5")}</td>
                    <td className="lead">
                      {/* Qty Total*/}
                      <bootstrap.Form.Control
                        type="number"
                        id="qtyTotal"
                        readOnly={true}
                        className="lead text-right"
                        {...register("qtyTotal")}
                      />
                    </td>
                  </tr>
                </tbody>
              </bootstrap.Table>
            </bootstrap.Col>
            <bootstrap.Col className="col-2"></bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Row>
            <bootstrap.Col>
              <p className="lead py-1">{t("step6.6V")}</p>
              {/* Check Yes*/}
              <bootstrap.Form.Check type="checkbox" inline reverse>
                <bootstrap.Form.Check.Label className="lead">
                  {t("step6.6V1")}
                </bootstrap.Form.Check.Label>
                <bootstrap.Form.Check.Input
                  type="checkbox"
                  id="checkYes"
                  onClick={(value) => {
                    setValue("checkNo", false);
                    if (value.target.checked) {
                      setCheckRequired(false);
                      clearErrors(["checkYes", "checkNo"]);
                    } else {
                      setCheckRequired(true);
                    }
                  }}
                  {...register("checkYes", {
                    required: checkRequired,
                  })}
                />
              </bootstrap.Form.Check>
              {/* Check No*/}
              <bootstrap.Form.Check type="checkbox" inline reverse>
                <bootstrap.Form.Check.Label className="lead">
                  {t("step6.6V2")}
                </bootstrap.Form.Check.Label>
                <bootstrap.Form.Check.Input
                  type="checkbox"
                  id="checkNo"
                  onClick={(value) => {
                    setValue("checkYes", false);
                    if (value.target.checked) {
                      setCheckRequired(false);
                      clearErrors(["checkYes", "checkNo"]);
                    } else {
                      setCheckRequired(true);
                    }
                  }}
                  {...register("checkNo", {
                    required: checkRequired,
                  })}
                />
              </bootstrap.Form.Check>
              {errors.checkYes && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    Yes {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
              {errors.checkNo && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    No {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
            </bootstrap.Col>
          </bootstrap.Row>

          <bootstrap.Row>
            <bootstrap.Col></bootstrap.Col>
          </bootstrap.Row>
          {watchCheckYes && (
            <div>
              <bootstrap.Row>
                <bootstrap.Col>
                  {/* Injury Details */}
                  <bootstrap.Form.Label htmlFor="injuryDetail" className="lead">
                    {t("step6.6W")}
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      as="textarea"
                      id="injuryDetail"
                      {...register("injuryDetail", {
                        validate: {
                          required: (value) =>
                            watchCheckYes && value.length > 0,
                        },
                      })}
                    />
                  </bootstrap.InputGroup>
                </bootstrap.Col>
              </bootstrap.Row>
              <bootstrap.Row>
                <bootstrap.Col>
                  {errors.injuryDetail && (
                    <bootstrap.Alert variant="danger">
                      <p className="lead text-danger text-center">
                        {t("errors.required")}
                      </p>
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
              </bootstrap.Row>
            </div>
          )}
          <bootstrap.Row>
            <bootstrap.Col>
              {/* Comments */}
              <bootstrap.Form.Label htmlFor="comments" className="lead">
                {t("step6.6X")}
              </bootstrap.Form.Label>
              <bootstrap.InputGroup className="mb-3">
                <bootstrap.Form.Control
                  as="textarea"
                  id="comments"
                  {...register("comments", { required: false })}
                />
              </bootstrap.InputGroup>
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Row>
            <bootstrap.Col>
              <p className="lead py-1">{t("step6.6Sign")}</p>
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Row>
            <bootstrap.Col>
              {errors.injuryDetail && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Row>
            <bootstrap.Col>
              <p className="lead">
                {t("step6.6Y")}
                <input
                  type="text"
                  className="signature titleLine"
                  id="signature"
                  {...register("signature", { required: true })}
                />
              </p>
              {errors.signature && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
            </bootstrap.Col>
            <bootstrap.Col>
              <p className="lead">
                {t("step6.6Z")}
                <input
                  type="text"
                  className="lead titleLine text-center"
                  defaultValue={new Date().toLocaleDateString()}
                  readOnly={true}
                  id="datePicker"
                  {...register("datePicker", { required: true })}
                />
              </p>
              {/* <RtrDatePicker
                control={control}
                name="datePicker"
                rules={{ required: true }}
              /> */}
              {errors.datePicker && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Row>
            <bootstrap.Col>
              <p className="lead">
                {t("step6.6ZA")}
                <input
                  type="text"
                  className="lead titleLine text-center"
                  id="sigName"
                  {...register("sigName", { required: true })}
                />
              </p>
              {errors.sigName && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
            </bootstrap.Col>
            <bootstrap.Col>
              <p className="lead">
                {t("step6.6ZB")}
                <input
                  type="text"
                  className=" lead text-center titleLine "
                  id="sigTitle"
                  {...register("sigTitle", { required: true })}
                />
              </p>
              {errors.title && (
                <bootstrap.Alert variant="danger">
                  <p className="lead text-danger text-center">
                    {t("errors.required")}
                  </p>
                </bootstrap.Alert>
              )}
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Row className="pt-2">
            {!isSubmitting && (
              <bootstrap.Button
                className="btn btn-primary btn-lg pt-1 justify-content-center"
                type="submit"
                id="SubmitButton"
              >
                Submit
              </bootstrap.Button>
            )}
            {isSubmitting && (
              <bootstrap.Button
                className="btn btn-primary btn-lg pt-1 justify-content-center"
                variant="primary"
                disabled={true}
              >
                <bootstrap.Spinner
                  as="span"
                  animation="border"
                  variant="status"
                  aria-hidden="true"
                ></bootstrap.Spinner>
              </bootstrap.Button>
            )}
          </bootstrap.Row>
        </bootstrap.Container>
      </bootstrap.Form>
    </div>
  );
};
